<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section v-for="article in listeEnvironnement" :key="article.id">
                        <div class="Fiche" v-if="article.type == 'Environnement'">
                            <div class="Infos Contact">
                                <h3>{{article.titre}}</h3>
                                <p class="paragraphe" v-html="article.texte"></p>
                                <div v-for="lien in article.liens" :key="lien.id">
                                    <a :href="lien">{{lien}}</a>
                                </div>
                                <router-link v-for="album in listeAlbums" :key="album.id" :to="{name: 'EnImage', params: {id : album.id}}">
                                    <div class="pochette-Album" v-if="album.id == article.album">
                                        <div class="derniereSlide">
                                            <img :src="album.images[2].url" alt="ArretBusNangis">
                                        </div>
                                        <div class="secondeSlide">
                                            <img :src="album.images[1].url" alt="ArretBusNangis">
                                        </div>
                                        
                                        <div class="premiereSlide">
                                            <img :src="album.images[0].url" alt="ArretBusNangis">
                                        </div>
                                        <div class="Titre-Album">
                                            <h5>{{album.titre_album}}</h5>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                            <div class="arret-bus">
                                <div class="contenu-droit-page" v-if="article.images != ''">
                                    <img :src="article.images" height="100%" width="100%">
                                </div>
                                <div class="contenu-droit-page" v-for="pdf in article.pdfs" :key="pdf.id">
                                    <iframe :src="pdf" height="100%" width="100%"></iframe>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Environnement',
    data () {
        return{
            listeEnvironnement:{
                id:0,
                titre: null,
                type: null,
                texte :null,              
                image:null,
                pdfs: {},
                liens: {},
                album: 0
            },
            listeAlbums:{
                id:0,
                titre_album: null,
                date_de_debut:null,
                date_de_fin: null,
                mots_cles:{
                    term_id:0,
                    name:null
                },
                images:{
                    id: 0,
                    url: null,
                    title: null
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.host+'environnement/v1/listeEnvironnement')
        .then(response =>{
        this.listeEnvironnement = response.data;

            for(var i = 0; this.listeEnvironnement.length > i; i++){
                    let pdf = new Array;
                    let lien = new Array;
                if(this.listeEnvironnement[i].pdf1 != null && this.listeEnvironnement[i].pdf1 != false){
                    pdf[0] = this.listeEnvironnement[i].pdf1;
                    if(this.listeEnvironnement[i].pdf2 != null && this.listeEnvironnement[i].pdf2 != false){
                        pdf[1] = this.listeEnvironnement[i].pdf2;
                        if(this.listeEnvironnement[i].pdf3 != null && this.listeEnvironnement[i].pdf3 != false){
                            pdf[2] = this.listeEnvironnement[i].pdf3;
                        }
                        
                    } 
                    this.listeEnvironnement[i].pdfs = pdf
                }
                if(this.listeEnvironnement[i].lien1 != null && this.listeEnvironnement[i].lien1 != false){
                    lien[0] = this.listeEnvironnement[i].lien1;
                    if(this.listeEnvironnement[i].lien2 != null && this.listeEnvironnement[i].lien2 != false){
                        lien[1] = this.listeEnvironnement[i].lien2;
                        if(this.listeEnvironnement[i].lien3 != null && this.listeEnvironnement[i].lien3 != false){
                            lien[2] = this.listeEnvironnement[i].lien3;
                        }
                    }
                    this.listeEnvironnement[i].liens = lien
                }
            }

            console.log(this.listeEnvironnement)

        })
        .catch(error => console.log(error))

        axios.get(param.host+'album/v1/listeAlbums')
        .then(response =>{
        this.listeAlbums = response.data;
            console.log('listeAlbums', this.listeAlbums)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Environnement'){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Environnement.vue